export default __webpack_public_path__ + "static/comparative-cost-of-observability-signals-75d487120df6091e4dd1ac12618bf9c5.png";